document.addEventListener("DOMContentLoaded", function () {
    var daysAfterToday = 1; // Set this to the number of days after today that the item will ship
    var today = new Date();
    var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));

    // If the ship date falls on a Sunday, set it to the following Monday
    if (shipDate.getDay() === 0) {
        shipDate.setDate(shipDate.getDate() + 1);
    }

    // Custom weekday abbreviations in German
    var weekdayMap = {
        0: "So",
        1: "Mo",
        2: "Di",
        3: "Mi",
        4: "Do",
        5: "Fr",
        6: "Sa"
    };

    var weekday = weekdayMap[shipDate.getDay()];
    var options = { month: 'long', day: 'numeric' };
    var formattedDate = shipDate.toLocaleDateString('de-DE', options);

    document.getElementById('shipping-date').textContent = `${weekday}, ${formattedDate}`;
});


jQuery('.question_product,.faq_question').click(function(){
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});

$("a[href='#reviews']").click(function(e) {
     e.preventDefault();
     document.querySelector('#reviews').scrollIntoView({ 
     behavior: 'smooth' 
  })
});

// $("a[href='#']").click(function(e) {
//      e.preventDefault();
//    document.querySelector('.landing_product_info').scrollIntoView({ 
//   behavior: 'smooth' 
// })
// });


$("a[href='#']").click(function(e) {
    e.preventDefault();
    
    // Scroll both elements into view
    document.querySelectorAll('.landing_product_info, .custom-app-zepto').forEach(function(element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    });
});

// $("a[href='/']").click(function(e) {
//      e.preventDefault();
//    document.querySelector('.product.grid').scrollIntoView({ 
//   behavior: 'smooth' 
// })
// });

// $(document).on("change", '.option_item input', function(e) {
// var main_div = $(this).parents('.custom_variants_landing_page');
// var doors = main_div.find('.options_flex').find('input:checked').val();
// var model = main_div.find('.options_select select').val();
// var title = doors +' / '+ model;

//   main_div.find('select[name="variant_id"] option').each(function(){
//       var loop_title = $(this).text();
//       if (loop_title == title ){
//      var id = $(this).val();
// main_div.find('select[name="variant_id"]').val(id);
// main_div.find('select[name="variant_id"]').trigger('change');
//       }
//   });
// });

// $(document).on("change", '.options_select select', function(e) {
// var main_div = $(this).parents('.custom_variants_landing_page');
// var doors = main_div.find('.options_flex').find('input:checked').val();
// var model = main_div.find('.options_select select').val();
// var title = doors +' / '+ model;
// main_div.find('select[name="variant_id"] option').each(function(){
//       var loop_title = $(this).text();
//       if (loop_title == title ){
//      var id = $(this).val();
// main_div.find('select[name="variant_id"]').val(id);
// main_div.find('select[name="variant_id"]').trigger('change');
//       }
//   });
// });

// $(document).on("change", 'select[name="variant_id"]', function(e) {
// var current_id = $(this).val();
// $('.price_flex').hide();
// $('.price_flex[data_tab="'+ current_id +'"]').show();
// $('.custom_checkout_button').attr('variant_id',current_id);    
// });




// // Save current state to local storage

var current_page_url = window.location.href;

function saveStateToLocalStorage() {
    var main_div = $('.custom_variants_landing_page');
    var doors = main_div.find('.options_flex').find('input:checked').val();
    var model = main_div.find('.options_select select').val();
    var variantId = main_div.find('select[name="variant_id"]').val();
    var state = {
        doors: doors,
        model: model,
        variantId: variantId
    };
    localStorage.setItem('product_variant_data', JSON.stringify(state));
}

  $('.custom_checkout_button').click(function(event){
      saveStateToLocalStorage();
    if (window.location.pathname.includes('products')) {
          localStorage.setItem('current_product_url', current_page_url);
    }
  });


// Event handler for changes in the option item inputs
$(document).on("change", '.option_item input', function(e) {
    var main_div = $(this).parents('.custom_variants_landing_page');
    var doors = main_div.find('.options_flex').find('input:checked').val();
    var model = main_div.find('.options_select select').val();
    var title = doors + ' / ' + model;

    main_div.find('select[name="variant_id"] option').each(function() {
        
        var loop_title = $(this).text();
        
        if (title == loop_title) {
            var id = $(this).val();
            
            main_div.find('select[name="variant_id"]').val(id);
            main_div.find('select[name="variant_id"]').trigger('change');
        }
    });
});

// Event handler for changes in the select dropdowns
$(document).on("change", '.options_select select', function(e) {
    var main_div = $(this).parents('.custom_variants_landing_page');
    var doors = main_div.find('.options_flex').find('input:checked').val();
    var model = main_div.find('.options_select select').val();
    var title = doors + ' / ' + model;

    main_div.find('select[name="variant_id"] option').each(function() {
        var loop_title = $(this).text();
        if (loop_title === title) {
            var id = $(this).val();
            main_div.find('select[name="variant_id"]').val(id);
            main_div.find('select[name="variant_id"]').trigger('change');
        }
    });

});

// Event handler for changes in the variant select dropdown
$(document).on("change", 'select[name="variant_id"]', function(e) {
    var current_id = $(this).val();
    $('.price_flex').hide();
    $('.price_flex[data_tab="'+ current_id +'"]').show();
    $('.custom_checkout_button').attr('variant_id', current_id);

});

// Retrieve and apply state from local storage on page load

if (window.location.pathname.includes('products')) {
  
  var current_url = localStorage.getItem('current_product_url');

  if(current_url == current_page_url){
  
    var savedState = localStorage.getItem('product_variant_data');
    
    if (savedState) {
        var state = JSON.parse(savedState);
        var main_div = $('.custom_variants_landing_page');

        // Set the option item input values
        main_div.find('.options_flex').find('input').each(function() {
            if ($(this).val() === state.doors) {
                $(this).prop('checked', true);
            }
        });

       main_div.find('.options_select select').each(function() {
            var select = $(this);
            var valueToSet = state.model; 
            if (valueToSet) {
                select.val(valueToSet).trigger('change');
            }
        });

        // Set the variant select dropdown value and trigger change
        var variantSelect = main_div.find('select[name="variant_id"]');
        variantSelect.val(state.variantId).trigger('change');
    }

  }
}


$(document).on("change", 'input[name="extra_property"]', function(e) {
  var text_value = $(this).val();
  if(text_value != ""){
   $(this).removeClass('error'); 
  } else {
   $(this).addClass('error');  
  }
});

